var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasIcons || _vm.hasDescription
    ? _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12 mb-2" }, [
          _c(
            "h4",
            {
              staticClass:
                "font-weight-bold primary-heading text-lowercase patcraft-text-underline",
              attrs: {
                "data-text": _vm.keyFeaturesText
                  ? _vm.keyFeaturesText.slice(0, 3)
                  : ""
              }
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.keyFeaturesText) + "\n        "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-12 mb-4" }, [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.keyFeaturesDescription) }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-12 mb-2" }, [
          _c(
            "div",
            { staticClass: "row d-flex flex-wrap align-items-baseline" },
            _vm._l(_vm.productData.marketAttributeIcons, function(item, index) {
              return item.iconImageURL || item.description
                ? _c(
                    "div",
                    {
                      key: index,
                      staticClass:
                        "marketing-icon-container col-lg-3 col-md-4 col-sm-6 col-6 mb-4 pl-3"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-row key-feature-icons" },
                        [
                          item.iconImageURL
                            ? _c("img", {
                                staticClass: "market-icon-img",
                                attrs: { src: item.iconImageURL }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.description
                            ? _c(
                                "span",
                                { staticClass: "icon-description mt-2" },
                                [_vm._v(_vm._s(item.description))]
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                : _vm._e()
            }),
            0
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }